var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechTailwind(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 62,
    viewBox: "0 0 100 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Tailwind_CSS_Logo 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_371_128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 60
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H100V60H0V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_371_128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 0C36.6667 0 28.3333 6.66667 25 20C30 13.3333 35.8333 10.8333 42.5 12.5C46.3037 13.45 49.0222 16.2111 52.0315 19.2648C56.9333 24.2407 62.6074 30 75 30C88.3333 30 96.6667 23.3333 100 10C95 16.6667 89.1667 19.1667 82.5 17.5C78.6963 16.55 75.9778 13.7889 72.9685 10.7352C68.0667 5.75926 62.3926 0 50 0ZM25 30C11.6667 30 3.33333 36.6667 0 50C5 43.3333 10.8333 40.8333 17.5 42.5C21.3037 43.4519 24.0222 46.2111 27.0315 49.2648C31.9333 54.2407 37.6074 60 50 60C63.3333 60 71.6667 53.3333 75 40C70 46.6667 64.1667 49.1667 57.5 47.5C53.6963 46.55 50.9778 43.7889 47.9685 40.7352C43.0667 35.7593 37.3926 30 25 30Z",
    fill: "#38BDF8"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechTailwind);
export default __webpack_public_path__ + "static/media/Tech-Tailwind.6ee209abd1de4c32f8f3a32f1f9b3c8b.svg";
export { ForwardRef as ReactComponent };